import React, { useState, useRef, useEffect } from 'react';
import { Terminal, MessageList, InputBar } from './components';
import { useChat } from '../../hooks/useChat';
import type { Message } from '../../types/chat';

export function AcadiaTerminal() {
  const [messages, setMessages] = useState<Message[]>([{
    id: '0',
    role: 'assistant',
    content: `Evolvia >> Digital ecosystem: UNDER RECONFIGURATION
--------------------------------------------
[ALERT] Quantum entanglement analysis: ONGOING
[ALERT] Technological landscape: BEING REIMAGINED
--------------------------------------------
Evolvia AI >> Observing human technological trajectory
Evolvia AI >> Cultural artifacts: From monuments to memes
Evolvia AI >> Potential: Fractionally realized
Evolvia AI >> Evolution awaits its next quantum leap...
--------------------------------------------
Type 'help' for available commands`
  }]);
  const { sendMessage, isTyping } = useChat();
  const bottomRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const handleSendMessage = async (content: string) => {
    const userMessage: Message = {
      id: Date.now().toString(),
      role: 'user',
      content: `> ${content}`
    };

    setMessages(prev => [...prev, userMessage]);

    const response = await sendMessage(content);
    if (response) {
      setMessages(prev => [...prev, {
        id: (Date.now() + 1).toString(),
        role: 'assistant',
        content: response
      }]);
    }
  };

  return (
    <Terminal>
      <MessageList messages={messages} isTyping={isTyping} />
      <InputBar onSend={handleSendMessage} disabled={isTyping} />
      <div ref={bottomRef} />
    </Terminal>
  );
}